/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupRecordingResponseExistingRecordingDupIsrcsInner } from './LookupRecordingResponseExistingRecordingDupIsrcsInner';
import {
    LookupRecordingResponseExistingRecordingDupIsrcsInnerFromJSON,
    LookupRecordingResponseExistingRecordingDupIsrcsInnerFromJSONTyped,
    LookupRecordingResponseExistingRecordingDupIsrcsInnerToJSON,
} from './LookupRecordingResponseExistingRecordingDupIsrcsInner';

/**
 * 
 * @export
 * @interface LookupRecordingResponseExistingRecording
 */
export interface LookupRecordingResponseExistingRecording {
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    recordingTitle: string;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    duration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    live?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    yearRecorded?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    countryOfRecording?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LookupRecordingResponseExistingRecording
     */
    recordingVersion?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LookupRecordingResponseExistingRecording
     */
    isrcs?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LookupRecordingResponseExistingRecording
     */
    pNames?: Array<string>;
    /**
     * Where this recording was found. Stored as a single-element list, matching the read model.
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    source: LookupRecordingResponseExistingRecordingSourceEnum;
    /**
     * The recording's id at `source`. Required unless `source` is `other`, and checked against that source's id shape.
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecording
     */
    recordingId?: string;
    /**
     * Recordings ISRCs in `isrcs` are being reassigned from, one entry per source recording
     * @type {Array<LookupRecordingResponseExistingRecordingDupIsrcsInner>}
     * @memberof LookupRecordingResponseExistingRecording
     */
    dupIsrcs?: Array<LookupRecordingResponseExistingRecordingDupIsrcsInner>;
}


/**
 * @export
 */
export const LookupRecordingResponseExistingRecordingSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type LookupRecordingResponseExistingRecordingSourceEnum = typeof LookupRecordingResponseExistingRecordingSourceEnum[keyof typeof LookupRecordingResponseExistingRecordingSourceEnum];


/**
 * Check if a given object implements the LookupRecordingResponseExistingRecording interface.
 */
export function instanceOfLookupRecordingResponseExistingRecording(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingTitle" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function LookupRecordingResponseExistingRecordingFromJSON(json: any): LookupRecordingResponseExistingRecording {
    return LookupRecordingResponseExistingRecordingFromJSONTyped(json, false);
}

export function LookupRecordingResponseExistingRecordingFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupRecordingResponseExistingRecording {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingTitle': json['recording_title'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'live': !exists(json, 'live') ? undefined : json['live'],
        'yearRecorded': !exists(json, 'year_recorded') ? undefined : json['year_recorded'],
        'countryOfRecording': !exists(json, 'country_of_recording') ? undefined : json['country_of_recording'],
        'recordingVersion': !exists(json, 'recording_version') ? undefined : json['recording_version'],
        'isrcs': !exists(json, 'isrcs') ? undefined : json['isrcs'],
        'pNames': !exists(json, 'p_names') ? undefined : json['p_names'],
        'source': json['source'],
        'recordingId': !exists(json, 'recording_id') ? undefined : json['recording_id'],
        'dupIsrcs': !exists(json, 'dup_isrcs') ? undefined : ((json['dup_isrcs'] as Array<any>).map(LookupRecordingResponseExistingRecordingDupIsrcsInnerFromJSON)),
    };
}

export function LookupRecordingResponseExistingRecordingToJSON(value?: LookupRecordingResponseExistingRecording | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording_title': value.recordingTitle,
        'duration': value.duration,
        'live': value.live,
        'year_recorded': value.yearRecorded,
        'country_of_recording': value.countryOfRecording,
        'recording_version': value.recordingVersion,
        'isrcs': value.isrcs,
        'p_names': value.pNames,
        'source': value.source,
        'recording_id': value.recordingId,
        'dup_isrcs': value.dupIsrcs === undefined ? undefined : ((value.dupIsrcs as Array<any>).map(LookupRecordingResponseExistingRecordingDupIsrcsInnerToJSON)),
    };
}

